// @flow

import gql from 'graphql-tag';

const isAuthenticated = gql`
  query isAuthenticatedQuery {
    isAuthenticated: isAuthenticatedV2
  }
`;

export default isAuthenticated;
